import React from 'react';

import { useBreakpointsCtx } from '../../ctx/breakpointProvider';

import Brand from '../brand';
import Navigation from '../navigation';
import NavigationMobile from '../navigationMobile';

import { Container } from './style';

const Navbar = () => {
  const { isScreenMinXl } = useBreakpointsCtx();

  return (
    <Container>
      <Brand />
      {isScreenMinXl ? <Navigation /> : <NavigationMobile />}
    </Container>
  );
};

export default Navbar;
